<app-create-asin-header></app-create-asin-header>

<div style="background: #3d3002;{{ minHeight }}">
  <div class="container mb-4" style="{{ minHeight2 }}">
    <div style="padding: 50px 30px">
      <div class="row justify-content-center">
        <div class="col-lg-10 col-xl-7">
          <div class="question-card">
            <h6
              style="
                padding: 15px;
                font-family: Helvetica Neue;
                border-bottom: 1px solid #d9d8d8;
              "
            >
              OTHER INFORMATION
            </h6>

            <div class="details">
              <div class="img-wrapper">
                <img
                  [src]="
                    this.previewDetails?.capturedImage ||
                    this.previewDetails?.dataStep1?.ninDetails?.photo
                  "
                  alt=""
                />
              </div>
              <div class="items">
                <div class="item">
                  <div class="title">Full Name</div>
                  <div class="value">
                    {{
                      this.previewDetails?.dataStep1?.ninDetails?.firstname +
                        " " +
                        this.previewDetails?.dataStep1?.ninDetails?.middlename +
                        " " +
                        this.previewDetails?.dataStep1?.ninDetails?.lastname
                    }}
                  </div>
                </div>
                <div class="item">
                  <div class="title">Gender</div>
                  <div class="value">
                    {{ this.previewDetails?.dataStep1?.ninDetails?.gender }}
                  </div>
                </div>
                <div class="item">
                  <div class="title">Phone Number</div>
                  <div class="value">
                    {{ this.previewDetails?.dataStep1?.ninDetails?.phone }}
                  </div>
                </div>
                <div class="item">
                  <div class="title">Date Of Birth</div>
                  <div class="value">
                    {{ this.previewDetails?.dataStep1?.ninDetails?.dob | date }}
                  </div>
                </div>
                <div class="item">
                  <div class="title">NIN</div>
                  <div class="value">
                    {{ this.previewDetails?.dataStep1?.ninDetails?.nin }}
                  </div>
                </div>
              </div>
            </div>

            <form
              [formGroup]="basicForm"
              (ngSubmit)="submit()"
              style="background-color: #fefefe; padding: 10px 40px"
            >
              <ng-container>
                <!-- EMPLOYMENT & INCOME DETAILS -->
                <div class="section">
                  <p class="title">EMPLOYMENT & INCOME DETAILS:</p>
                  <div class="row g-3 align-items-end">
                    <div class="col-md-6 col-lg-4 tax-input-group">
                      <label>Income Category</label>
                      <select
                        formControlName="incomeCategory"
                        class="form-select"
                      >
                        <option disabled selected>
                          -- Select Income Category --
                        </option>
                        <option value="employed">Employed</option>
                        <option value="selfEmployed">Self Employed</option>
                        <option value="unemployed">Unemployed</option>
                      </select>
                      <app-error-message
                        controlName="incomeCategory"
                        label="Income Category"
                        [form]="basicForm"
                      ></app-error-message>
                    </div>

                    <div
                      class="col-md-6 col-lg-4 tax-input-group"
                      *ngIf="
                        basicForm.get('incomeCategory')?.value == 'employed'
                      "
                    >
                      <label>Name Of Employer</label>
                      <input
                        type="text"
                        class="form-control"
                        formControlName="employerName"
                        placeholder="Enter Employer Name"
                      />
                      <app-error-message
                        controlName="employerName"
                        label="Employer Name"
                        [form]="basicForm"
                      ></app-error-message>
                    </div>

                    <div
                      class="col-md-6 col-lg-4 tax-input-group"
                      *ngIf="
                        basicForm.get('incomeCategory')?.value == 'employed'
                      "
                    >
                      <label>Income/Salary Range Per Annum</label>
                      <select formControlName="incomeRange" class="form-select">
                        <option disabled selected>
                          -- Select Income Range --
                        </option>
                        <option value="₦100,000 – ₦1,000,000">
                          ₦100,000 – ₦1,000,000
                        </option>
                        <option value="₦1,001,000 – ₦5,000,000">
                          ₦1,001,000 – ₦5,000,000
                        </option>
                        <option value="₦501,000 - 10,000,000">
                          ₦501,000 - 10,000,000
                        </option>
                        <option value="₦10,001,000 - 20,000,000">
                          ₦10,001,000 - 20,000,000
                        </option>
                        <option value="₦20,001,000 - 50,000,000">
                          ₦20,001,000 - 50,000,000
                        </option>
                        <option value="Above 50,000,000">
                          Above 50,000,000
                        </option>
                      </select>
                      <app-error-message
                        controlName="incomeRange"
                        label="Income Range"
                        [form]="basicForm"
                      ></app-error-message>
                    </div>

                    <div
                      class="col-md-6 col-lg-4 tax-input-group"
                      *ngIf="
                        basicForm.get('incomeCategory')?.value ==
                          'selfEmployed' ||
                        basicForm.get('incomeCategory')?.value == 'unemployed'
                      "
                    >
                      <label>Source Of Income</label>
                      <!-- <input class="form-control" formControlName="sourceOfIncome" placeholder="Enter Source of Income" /> -->

                      <ng-select
                        [items]="sourceOfIncome"
                        bindValue="id"
                        bindLabel="name"
                        placeholder="-- Select Source of Income --"
                        formControlName="sourceOfIncome"
                      ></ng-select>

                      <app-error-message
                        controlName="sourceOfIncome"
                        label="Source of Income"
                        [form]="basicForm"
                      ></app-error-message>
                    </div>

                    <div
                      class="col-md-6 col-lg-4 tax-input-group"
                      *ngIf="
                        basicForm.get('incomeCategory')?.value ==
                          'selfEmployed' ||
                        basicForm.get('incomeCategory')?.value == 'unemployed'
                      "
                    >
                      <label>Total Annual Income(₦)</label>
                      <input
                        class="form-control"
                        formControlName="totalAnnualIncome"
                        type="number"
                        min="0"
                        placeholder="Enter Total Annual Income"
                      />
                      <app-error-message
                        controlName="totalAnnualIncome"
                        label="Total Annual Income"
                        [form]="basicForm"
                      ></app-error-message>
                    </div>

                    <div
                      class="col-md-6 col-lg-4 tax-input-group"
                      *ngIf="
                        basicForm.get('incomeCategory')?.value == 'selfEmployed'
                      "
                    >
                      <label>Industry</label>
                      <select
                        class="form-control small-option-font"
                        formControlName="natureOfBusiness"
                      >
                        <option value="">-- Select--</option>
                        <option [value]="0">Uncategorized</option>
                        <option
                          [value]="businessNature?.id"
                          *ngFor="let businessNature of businessNatureList"
                        >
                          {{ businessNature?.name | titlecase }}
                        </option>
                      </select>
                    </div>
                    <div class="col-md-6 col-lg-4 tax-input-group">
                      <label>Do you have a vehicle?</label>
                      <select formControlName="hasVehicle" class="form-select">
                        <option disabled selected>-- Select Option --</option>
                        <option [value]="true">Yes</option>
                        <option [value]="false">No</option>
                      </select>
                      <app-error-message
                        controlName="hasVehicle"
                        label="Option"
                        [form]="basicForm"
                      ></app-error-message>
                    </div>

                    <div
                      class="col-md-6 col-lg-4 tax-input-group"
                      *ngIf="basicForm.get('hasVehicle')?.value"
                    >
                      <label>How Many Vehicles Owned?</label>
                      <input
                        type="number"
                        min="1"
                        formControlName="numberOfVehicles"
                        class="form-control"
                      />

                      <app-error-message
                        controlName="numberOfVehicles"
                        label="Number of Vehicles"
                        [form]="basicForm"
                      ></app-error-message>
                    </div>

                    <div class="col-md-6 col-lg-4 tax-input-group">
                      <label>Do you have a property?</label>
                      <select formControlName="hasProperty" class="form-select">
                        <option disabled selected>-- Select Option --</option>
                        <option [value]="true">Yes</option>
                        <option [value]="false">No</option>
                      </select>
                      <app-error-message
                        controlName="hasProperty"
                        label="Option"
                        [form]="basicForm"
                      ></app-error-message>
                    </div>

                    <div
                      class="col-md-6 col-lg-4 tax-input-group"
                      *ngIf="basicForm.get('hasProperty')?.value == 'true'"
                    >
                      <!-- <label>Property Type</label>
                      <select formControlName="propertyType" class="form-select">
                        <option disabled selected>-- Select Property Type --</option>
                        <option value="Land">Land</option>
                        <option value="Livestock">Livestock</option>
                        <option value="Houses">Houses</option>
                        <option value="Others">Others</option>
                      </select> -->

                      <label>Assets/Property Type</label>
                      <ng-select
                        [items]="assetsOptions"
                        bindLabel="name"
                        bindValue="id"
                        [multiple]="true"
                        placeholder="Select highest level of education..."
                        formControlName="propertyType"
                      ></ng-select>
                    </div>
                  </div>
                </div>

                <!-- CONTACT INFORMATION -->
                <div class="section">
                  <p class="title">RESIDENTIAL INFORMATION:</p>
                  <div class="row g-3 align-items-end">
                    <div class="col-md-6 col-lg-4 tax-input-group">
                      <label>Email Address</label>
                      <input
                        type="email"
                        class="form-control"
                        formControlName="email"
                        placeholder="Enter Email Address"
                      />
                      <app-error-message
                        controlName="email"
                        label="Email"
                        [form]="basicForm"
                      ></app-error-message>
                    </div>

                    <!-- <div class="col-md-6 col-lg-4 tax-input-group">
                                    <label>Alternative Email Address</label>
                                    <input type="email" class="form-control" formControlName="alternativeEmail"
                                      placeholder="Enter Alternative Email" />
                                    <app-error-message controlName="alternativeEmail" label="Alternative Email"
                                      [form]="basicForm"></app-error-message>
                                  </div> -->

                    <div class="col-md-6 col-lg-4 tax-input-group">
                      <label>State</label>
                      <ng-select
                        (change)="onStateChange()"
                        [items]="state"
                        bindLabel="name"
                        placeholder="-- Select State --"
                        formControlName="state"
                      ></ng-select>
                      <app-error-message
                        controlName="state"
                        label="State"
                        [form]="basicForm"
                      ></app-error-message>
                    </div>

                    <div class="col-md-6 col-lg-4 tax-input-group">
                      <label>LGA</label>
                      <ng-select
                        [items]="lgas"
                        bindLabel="name"
                        placeholder="-- Select LGA --"
                        formControlName="lga"
                      ></ng-select>
                      <app-error-message
                        controlName="lga"
                        label="LGA"
                        [form]="basicForm"
                      ></app-error-message>
                    </div>
                  </div>
                </div>

                <!-- RENT INFORMATION -->
                <div class="section">
                  <p class="title">RENT INFORMATION:</p>
                  <div class="row g-3 align-items-end">
                    <div class="col-md-6 col-lg-4 tax-input-group">
                      <label>Accommodation Type</label>
                      <select
                        formControlName="accommodationType"
                        class="form-select"
                      >
                        <option disabled selected>
                          -- Select Accommodation Type --
                        </option>
                        <option value="rented">Rented</option>
                        <option value="owned">Owned</option>
                        <option value="leased">Leased</option>
                      </select>
                      <app-error-message
                        controlName="accommodationType"
                        label="Accommodation Type"
                        [form]="basicForm"
                      ></app-error-message>
                    </div>
                    <div
                      class="col-md-4 tax-input-group"
                      *ngIf="
                        basicForm?.get('accommodationType')?.value == 'owned'
                      "
                    >
                      <label>Building Type</label>
                      <select
                        formControlName="buildingType"
                        class="form-select"
                      >
                        <option value="bungalow">Bungalow</option>
                        <option value="flat">Flat</option>
                        <option value="duplex">Duplex</option>
                      </select>
                      <app-error-message
                        controlName="buildingType"
                        label="Building Type"
                        [form]="basicForm"
                      ></app-error-message>
                    </div>

                    <div
                      class="col-md-6 col-lg-4 tax-input-group"
                      *ngIf="
                        ['rented', 'leased'].includes(
                          basicForm.get('accommodationType').value
                        )
                      "
                    >
                      <label>Rent Period Covered</label>
                      <input
                        class="form-control"
                        placeholder="rentPeriodCovered"
                        formControlName="rentPeriodCovered"
                      />
                    </div>
                    <div
                      class="col-md-4 tax-input-group"
                      *ngIf="
                        ['rented', 'leased'].includes(
                          basicForm.get('accommodationType').value
                        )
                      "
                    >
                      <label>Period Type</label>
                      <select formControlName="periodType" class="form-select">
                        <option disabled selected>
                          -- Select Period Type --
                        </option>
                        <option value="monthly">Monthly</option>
                        <option value="yearly">Yearly</option>
                      </select>
                      <app-error-message
                        controlName="periodType"
                        label="Period Type"
                        [form]="basicForm"
                      ></app-error-message>
                    </div>
                    <div
                      class="col-md-4 tax-input-group"
                      *ngIf="
                        ['rented', 'leased'].includes(
                          basicForm.get('accommodationType').value
                        )
                      "
                    >
                      <label>Annual Rent Amount</label>
                      <input
                        type="number"
                        class="form-control"
                        formControlName="annualRentAmount"
                      />
                      <app-error-message
                        controlName="annualRentAmount"
                        label="Annual Rent Amount"
                        [form]="basicForm"
                      ></app-error-message>
                    </div>

                    <div
                      class="col-md-6 tax-input-group"
                      *ngIf="
                        ['rented', 'leased'].includes(
                          basicForm.get('accommodationType')?.value
                        )
                      "
                    >
                      <label>Management Type</label>
                      <select
                        formControlName="propertyManagement"
                        class="form-select"
                      >
                        <option disabled selected>
                          -- Select Management Type --
                        </option>

                        <option value="Landlord">Landlord</option>
                        <option value="Caretaker">Caretaker</option>
                        <option value="Property Manager">
                          Property Manager
                        </option>
                      </select>
                      <app-error-message
                        controlName="propertyManagement"
                        label="Management Type"
                        [form]="basicForm"
                      ></app-error-message>
                    </div>
                  </div>
                </div>

                <!-- LANDLORD INFORMATION -->
                <div
                  class="section"
                  *ngIf="
                    ['rented', 'leased'].includes(
                      basicForm.get('accommodationType').value
                    )
                  "
                >
                  <p class="title">LANDLORD INFORMATION:</p>
                  <div class="row g-3 align-items-end">
                    <div class="col-md-6 col-lg-4 tax-input-group">
                      <label>Full Name</label>
                      <input
                        type="text"
                        class="form-control"
                        formControlName="landlordFullName"
                        placeholder="Enter Full Name"
                      />
                      <app-error-message
                        controlName="landlordFullName"
                        label="Landlord Full Name"
                        [form]="basicForm"
                      ></app-error-message>
                    </div>

                    <div class="col-md-6 col-lg-4 tax-input-group">
                      <label>Phone Number</label>
                      <input
                        type="tel"
                        class="form-control"
                        formControlName="landlordPhoneNumber"
                        placeholder="Enter Phone Number"
                      />
                      <app-error-message
                        controlName="landlordPhoneNumber"
                        label="Landlord Phone Number"
                        [form]="basicForm"
                      ></app-error-message>
                    </div>

                    <div class="col-md-6 col-lg-4 tax-input-group">
                      <label>ASIN (Optional)</label>
                      <input
                        type="text"
                        class="form-control"
                        formControlName="landlordAsin"
                        placeholder="Enter ASIN"
                      />
                      <app-error-message
                        controlName="landlordAsin"
                        label="ASIN"
                        [form]="basicForm"
                      ></app-error-message>
                    </div>

                    <div class="col-md-6 col-lg-4 tax-input-group">
                      <label>Email (Optional)</label>
                      <input
                        type="email"
                        class="form-control"
                        formControlName="landlordEmail"
                        placeholder="Enter Email Address"
                      />
                      <app-error-message
                        controlName="landlordEmail"
                        label="Landlord Email"
                        [form]="basicForm"
                      ></app-error-message>
                    </div>

                    <div class="col-md-6 col-lg-4 tax-input-group">
                      <label>Does Landlord Live In Same Apartment?</label>
                      <select
                        formControlName="doesLandlordLiveSameApartment"
                        class="form-select"
                      >
                        <option disabled selected>-- Select Option --</option>
                        <option [value]="true">Yes</option>
                        <option [value]="false">No</option>
                      </select>
                      <app-error-message
                        controlName="doesLandlordLiveSameApartment"
                        label="Does Landlord Live Same Apartment"
                        [form]="basicForm"
                      ></app-error-message>
                    </div>

                    <div
                      class="col-md-6 col-lg-4 tax-input-group"
                      *ngIf="
                        basicForm.get('doesLandlordLiveSameApartment')
                          ?.value === 'false'
                      "
                    >
                      <label>Address</label>
                      <input
                        type="text"
                        class="form-control"
                        formControlName="landlordAddress"
                        placeholder="Enter Address"
                      />
                      <app-error-message
                        controlName="landlordAddress"
                        label="Landlord Address"
                        [form]="basicForm"
                      ></app-error-message>
                    </div>
                  </div>
                </div>
                <!-- <p class="mb-4">Answer Basic Information</p> -->

                <!-- MARRIED RADIO -->
                <!-- <div class="d-flex flex-row align-items-center mb-4">
                                                  <span class="me-4" style="color: #666;font-size: 15px;">Are you married?</span>
                                                  <div class="d-flex flex-row align-items-center">
                                                    <div class="d-flex flex-row align-items-center me-4">
                                                      <label style="font-size: 13px;" class="me-2">Yes</label>
                                                      <input name="isMarried" [value]=true formControlName="isMarried" type="radio" />
                                                    </div>
                                                    <div class="d-flex flex-row align-items-center">
                                                      <label style="font-size: 13px;" class="me-2">No</label>
                                                      <input name="isMarried" [value]=false formControlName="isMarried" type="radio" />
                                                    </div>
                                                  </div>
                                                  <app-error-message controlName="isMarried" label="Marital Status" [form]="basicForm"></app-error-message>
                                                </div> -->

                <!-- PROPERTY RADIO -->
                <!-- <div class="d-flex flex-row align-items-center mb-4">
                                                  <span class="me-4" style="color: #666;font-size: 15px;">Do you own a property?</span>
                                                  <div class="d-flex flex-row align-items-center">
                                                    <div class="d-flex flex-row align-items-center me-4">
                                                      <label style="font-size: 13px;" class="me-2">Yes</label>
                                                      <input name="isProperty" type="radio" [value]=true formControlName="isProperty" />
                                                    </div>
                                                    <div class="d-flex flex-row align-items-center">
                                                      <label style="font-size: 13px;" class="me-2">No</label>
                                                      <input name="isProperty" type="radio" [value]=false formControlName="isProperty" />
                                                    </div>
                                                  </div>
                                                  <app-error-message controlName="isProperty" label="Property Ownership" [form]="basicForm"></app-error-message>
                                                </div> -->

                <!-- EMPLOYED RADIO -->
                <!-- <div class="d-flex flex-row align-items-center mb-4">
                                                  <span class="me-4" style="color: #666;font-size: 15px;">Are you employed?</span>
                                                  <div class="d-flex flex-row align-items-center">
                                                    <div class="d-flex flex-row align-items-center me-4">
                                                      <label style="font-size: 13px;" class="me-2">Yes</label>
                                                      <input name="isEmployed" type="radio" [value]=true formControlName="isEmployed" />
                                                    </div>
                                                    <div class="d-flex flex-row align-items-center">
                                                      <label style="font-size: 13px;" class="me-2">No</label>
                                                      <input name="isEmployed" type="radio" [value]=false formControlName="isEmployed" />
                                                    </div>
                                                  </div>
                                                  <app-error-message controlName="isEmployed" label="Employment Status" [form]="basicForm"></app-error-message>
                                                </div> -->

                <!-- SUBMIT -->
                <div
                  class="d-flex justify-content-center w-100 gap-2 mt-5 flex-wrap"
                >
                  <button
                    style="
                      background-color: #1e1e1e;
                      color: white;
                      border-radius: 4px;
                      padding-inline: 30px;
                    "
                    (click)="goBack.emit()"
                  >
                    Back
                  </button>
                  <button
                    type="submit"
                    class="gold-btn d-flex align-items-center justify-content-center px-5 gap-2"
                    [disabled]="isSubmitting"
                  >
                    <span *ngIf="isSubmitting" class="spinner-light"></span>
                    <span>{{
                      isSubmitting ? "Generating..." : "Generate ASIN"
                    }}</span>
                  </button>
                </div>
              </ng-container>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>

  <app-footer></app-footer>
</div>

<!-- Old Form -->
<!-- <form [formGroup]="basicForm" (ngSubmit)="submit()">
                            <div class="row mb-3">

                                <div class="col-md-6 mb-3">
                                    <div class="input-group-div">
                                        <label>Contact Address</label>
                                        <input formControlName="address" />
                                    </div>
                                </div>
                                <div class="col-md-6 mb-3">
                                    <div class="input-group-div">
                                        <label>State</label>
                                        <select formControlName="state" (change)="getLga()">
                                            <option value="6">ANAMBRA STATE</option>
                                            <option [value]="state.id" *ngFor="let state of state">{{state.name}}
                                            </option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-md-6 mb-3">
                                    <div class="input-group-div">
                                        <label>LGA</label>
                                        <select formControlName="lga" (change)="getArea()">
                                            <option value="">Select LGA</option>
                                            <option [value]="state.id" *ngFor="let state of lga">{{state.name}}</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-md-6 mb-3">
                                    <div class="input-group-div">
                                        <label>Area</label>
                                        <select formControlName="area">
                                            <option value="">Selete Area</option>
                                            <option [value]="state.id" *ngFor="let state of area">{{state.name}}
                                            </option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <hr>
                 
                            <div class="row mb-3">
                                <div class="col-md-6 mb-3">
                                    <div class="input-group-div">
                                        <label>State Of Origin</label>
                                        <select formControlName="stateOfOrigin" (change)="getLga2()">
                                            <option value="6">Select State</option>
                                            <option [value]="state.id" *ngFor="let state of state2">{{state.name}}
                                            </option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-md-6 mb-3">
                                    <div class="input-group-div">
                                        <label>LGA Of Origin</label>
                                        <select formControlName="stateOfOriginLga" (change)="getArea2()">
                                            <option value="6">Select LGA</option>
                                            <option [value]="state.id" *ngFor="let state of lga2">{{state.name}}
                                            </option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-md-6 mb-3" style="display: none">
                                    <div class="input-group-div">
                                        <label>Area Of Origin</label>
                                        <select formControlName="stateOfOriginArea">
                                            <option value="6">Select Area Council</option>
                                            <option [value]="state.id" *ngFor="let state of area2">{{state.name}}
                                            </option>
                                        </select>
                                    </div>
                                </div>

                                <div class="col-md-6 mb-3">
                                    <div class="input-group-div">
                                        <label>Address</label>
                                        <input />
                                    </div>
                                </div>
                            </div>



                            <div class="row mb-3">

                                <div class="col-md-6">
                                    <div class="input-group-div">
                                        <label>Source Of Income</label>
                                        <select formControlName="sourceOfIncome">
                                            <option value="">Source of Income</option>
                                            <option [value]="state.id" *ngFor="let state of sourceOfIncome">
                                                {{state.name}}</option>
                                        </select>
                                    </div>
                                </div>

                                <div class="col-md-6 mb-3">
                                    <div class="input-group-div">
                                        <label>Highest Level Of Education</label>
                                        <select formControlName="highestEducation">
                                            <option>Select Higher Level of Education</option>
                                            <option>Ph'D</option>
                                            <option>MSC</option>
                                            <option>BSC</option>
                                            <option>BED</option>
                                            <option>BENG</option>
                                            <option>LLB</option>
                                            <option>HND</option>
                                            <option>NCE</option>
                                            <option>OND</option>
                                            <option>DIPLOMA</option>
                                            <option>WASSCE</option>
                                        </select>
                                    </div>
                                </div>

                            </div>
                            <br />
                            <div class="submit-div">
                                <button type="submit" class="button" [disabled]="basicForm.invalid">Continue</button>
                            </div>
                        </form> -->
